import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-api-integration-create',
  templateUrl: './api-integration-create.component.html',
  styleUrls: ['./api-integration-create.component.scss'],
})
export class ApiIntegrationCreateComponent implements OnInit {

  accessKey: any;
  openList: any;
  url: string;
  urlError: string;
  getApiKey: string;
  getSecretKey: string;
  getApiKeyError: string;
  getSecretKeyError: string;
  accessKeyErrorMessage: string;
  apiName: string;
  apiNameError: string;
  apiSettingsId: string;
  displaySetting: boolean = false;
  constructor(private alertService: AlertService, private http: HttpClient, private g: Globals, private api: ApiIntegration, public user: User, private route: ActivatedRoute, private router: Router) {
    //this.getOpenList();
  }

  getOpenList() {
    this.api.getApiSettingsList(this.apiSettingsId, this.user.accountOwnerId, "1").subscribe((data: any) => {
      this.openList = data.openApiSettingsResponses;
      this.openList.forEach((notification) => {
        notification.apiSettingsResponses.forEach((n) => {
          if (n.notify === 'ON') {
            n.enabled = true;
          } else {
            n.enabled = false;
          }
        });
      });

    }, err => {
      console.log(err);
    });
  }

  sliceUPto(num) {
    if (num) {
      if (num % 2 == 0) {
        return num / 2;
      } else {
        return (num + 1) / 2;
      }
    } else {
      return 0;
    }
  }

  ngOnInit() {
  }

  keyGenerate() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/generateAPIKey?accountOwnerId=' + this.user.accountOwnerId, {
      //"accountOwnerId": this.user.accountOwnerId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.getApiKey = data['apiKey'];
          this.getSecretKey = data['secretKey'];
          this.alertService.success('Secrete Key', 'Generated Successfully');
        }
        else {
          this.accessKeyErrorMessage = data['message'];
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";

      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  save() {

    this.getApiKeyError = "";
    this.getSecretKeyError = "";
    this.urlError = "";
    this.apiNameError = "";

    if (!this.getApiKey) {
      this.getApiKeyError = "Generate the Apikey And SecreteKey";
    }

    if (!this.getSecretKey) {
      this.getSecretKeyError = "Generate the Apikey And SecreteKey";
    }

    if (!this.apiName) {
      this.apiNameError = "Please Enter Api Name";
    }

    if (!this.url) {
      this.urlError = "Please Enter The URL";
    }

    if (this.apiNameError != "" || this.getApiKeyError != "" || this.getSecretKeyError != "" || this.urlError != "") {
      return false;
    }

    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/saveAPIKey', {
      "accountOwnerId": this.user.accountOwnerId,
      "apiKey": this.getApiKey,
      "organizationId": this.user.organizationId,
      "redirectUrl": this.url,
      "secretKey": this.getSecretKey,
      "apiName": this.apiName
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.displaySetting = true;
          this.apiSettingsId = data['id'];
          this.alertService.success('Created Successfully', '');
          this.getOpenList();
          //this.router.navigate(['/admin/myAccountList']);
        }
        else {
          this.accessKeyErrorMessage = data['message'];
          this.alertService.error('Error', data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  openUpdateStatus(n, id) {
    // alert("value ::" + n.displayPriority);
    //if (n.enabled == true) {
    //this.notificationId = n.settingsId;
    //} else {
    //this.notificationId = n.id;
    //}
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/createApiSettings', {
      "accountOwnerId": this.user.accountOwnerId,
      "openApiTypeId": n.openApiTypeId,
      "id": n.settingsId,
      "notify": n.enabled ? "OFF" : "ON",
      "organizationId": 1,
      "userApiAccountId": this.apiSettingsId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == "200") {
          this.alertService.success('Api', 'Status Updated Successfully');
          this.getOpenList();
          //this.router.navigate(['/admin/myAccountList']);
        } else {
          this.alertService.error(data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

}
